import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
.sm {
  font-size: 60px;
  font-weight: semibold;
}

.lg {
  font-size: 80px;
  font-weight: bold;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.category-item:hover .tooltip {
  opacity: 1;
}`],
})
export class PageMainComponent implements OnInit {

    public keywords = '';
    public searchMode = 'name';
    public categories = [
        { title: '연구자', num: 0, icon: 'fa-solid fa-user', exp: '연구자 수' },
        // { title: 'ORGANIZATION', num: 0, icon: 'fa-solid fa-building', exp: 총 기관 정보 수' },
        { title: '성과물', num: 0, icon: 'fa-solid fa-bookmark', exp: '성과물 수' },
    ];
    public category = {};

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        this.load();
    }

    public async search() {
        if (!this.keywords || this.keywords.trim() === '') {
            await this.service.alert.show({
                title: "",
                action: "확인",
                actionBtn: "error",
                message: "검색어를 입력해주세요.",
                cancel: false,
            });
            await this.service.render();
            return;
        }
        this.router.navigate(['/list'], { queryParams: { mode: this.searchMode, keywords: this.keywords } });

    }

    public async load() {
        // const { code, data } = await wiz.call("load");
        const data = { '성과물': 7432611, '기관': 95779, '연구자': 7001582 };
        this.categories = this.categories.map(cat => {
            const key = cat.title.toLowerCase();
            return {
                ...cat,
                num: data[key] ?? 0
            };
        });
        await this.service.render();
        this.category = this.categories.find(cat => cat.title === '연구자');
        await this.service.render();
    }

    public change(c) {
        this.category = this.categories?.find(cat => cat.title === c) || null;
        this.service.render();
    }

    public formatNum(num: number | string): string {
        return Number(num).toLocaleString('ko-KR');
    }


}

export default PageMainComponent;